module.exports = __webpack_public_path__ + "resources/img/main11_m.2ed7874aa49f7faeb33b5db070b1900f.png";